<template>
    <div class="flex flex-col items-center max-w-3xl mx-auto">
        <div class="flex w-full flex-col gap-8 mt-10">
            <div
                class="bg-theme-card border border-theme-border rounded-xl p-6"
            >
                <h3 class="font-semibold text-theme-base mb-2">
                    Descripción del negocio (Lo puedes poner más adelante)
                </h3>
                <p class="text-sm text-theme-muted mb-3">
                    Cuéntale a tus clientes de qué se trata tu negocio.
                </p>
                <custom-textarea
                    v-model="businessDescription"
                    maxlength="500"
                    :rows="3"
                    placeholder="Describe tu negocio en pocas palabras..."
                />
                <p class="text-xs text-theme-muted text-right mt-1">
                    {{ businessDescription.length }}/500
                </p>
            </div>

            <div
                class="bg-theme-card border border-theme-border rounded-xl p-6"
            >
                <h3 class="font-semibold text-theme-base mb-4">
                    Logo (Lo puedes subir más adelante)
                </h3>
                <image-uploader
                    default-alt="Logo ícono"
                    :initial-url="onboardingDraft.logoIconUrl"
                    :preview-width="100"
                    :preview-height="100"
                    @updated="onLogoUpdated"
                />
            </div>

            <div
                class="bg-theme-card border border-theme-border rounded-xl p-6"
            >
                <h3 class="font-semibold text-theme-base mb-4">
                    Colores de tu marca (Lo puedes poner más adelante)
                </h3>

                <brand-color-picker
                    v-model="stackColors"
                    :business-name="previewCatalog.businessName"
                    :logo-url="onboardingDraft.logoIconUrl"
                    :display-mode="onboardingDraft.displayMode"
                    default-mode="palette"
                />
            </div>
        </div>

        <p v-if="error" class="text-theme-danger text-sm mt-4">
            {{ error }}
        </p>
    </div>
</template>

<script>
import onboardingCompletedGuard from "@/mixins/onboardingCompletedGuard";
import onboardingStepNavigation from "@/mixins/onboardingStepNavigation";
import { mapActions, mapMutations } from "vuex";

import BrandColorPicker from "@/components/editor/BrandColorPicker.vue";
import CustomTextarea from "@/components/utils/CustomTextarea.vue";
import ImageUploader from "@/components/utils/ImageUploader.vue";

export default {
    name: "OnboardingBrandingPage",

    components: {
        BrandColorPicker,
        CustomTextarea,
        ImageUploader
    },

    mixins: [onboardingCompletedGuard, onboardingStepNavigation],

    data() {
        return {
            stepKey: "branding",
            stackColors: {
                primary: "#284D6F",
                emphasis: "#FD951E",
                background: "#FFFFFF",
                text: "#000000"
            },
            businessDescription: "",
            error: null,
            isLoading: false
        };
    },

    computed: {
        localStepperUi() {
            return {
                nextDisabled: false,
                loading: this.isLoading,
                nextLabel: "",
                nextVariant: "primary"
            };
        }
    },

    watch: {
        stackColors: {
            deep: true,
            handler(value) {
                this.SET_DRAFT_STACK_COLORS(value);
            }
        },
        businessDescription(value) {
            this.SET_DRAFT_BUSINESS_DESCRIPTION(value);
        }
    },

    async mounted() {
        await this.ensureOnboardingStatus();
        if (this.redirectIfOnboardingCompleted()) return;
        const draft = this.onboardingDraft;
        if (draft.stackColors) {
            this.stackColors = { ...this.stackColors, ...draft.stackColors };
        }
        if (draft.businessDescription) {
            this.businessDescription = draft.businessDescription;
        }
    },

    methods: {
        ...mapActions("onboarding", ["submitBranding"]),
        ...mapMutations("control", ["SET_TENANT_STACK_COLORS"]),
        ...mapMutations("onboarding", [
            "SET_DRAFT_LOGO",
            "SET_DRAFT_STACK_COLORS",
            "SET_DRAFT_BUSINESS_DESCRIPTION"
        ]),

        onLogoUpdated(url) {
            this.SET_DRAFT_LOGO(url);
        },

        stepperNext() {
            if (this.readOnly) {
                this.goToNextReachable();
                return;
            }
            this.continueStep();
        },

        async continueStep() {
            if (this.isLoading) return;

            this.isLoading = true;
            this.error = null;
            try {
                const payload = {};
                if (this.onboardingDraft.logoIconUrl) {
                    payload.logoIconUrl = this.onboardingDraft.logoIconUrl;
                }
                payload.stackColors = { ...this.stackColors };
                if (this.businessDescription.trim()) {
                    payload.businessDescription =
                        this.businessDescription.trim();
                }

                const data = await this.submitBranding(payload);
                this.SET_TENANT_STACK_COLORS(payload.stackColors);
                this.navigateByFlow(data.onboardingFlow);
                this.isLoading = false;
            } catch (err) {
                this.isLoading = false;
                this.error =
                    err.message || "Error al guardar la personalización";
            }
        },

        navigateByFlow(flow) {
            if (!flow) return;
            if (flow.status === "completed" && !flow.nextStep) {
                this.$router.push(this.completionRoute);
                return;
            }
            const nextRoute =
                flow.status === "completed" && flow.nextStep
                    ? this.routeForStep(flow.nextStep)
                    : this.routeForStep(flow.step);
            if (nextRoute) {
                this.$router.push(nextRoute);
            }
        }
    }
};
</script>
